// This file is auto-generated by a custom SVGO plugin (defined in svgo.config.js)
// It contains a list of all SVGs that use currentColor

export const svgsUsingCurrentColor: readonly string[] = [
  "accounting-coins-stack",
  "ads-click",
  "adults",
  "alarm-bell-check",
  "alarm-bell-off",
  "alert-circle",
  "alert-triangle",
  "apps-simple",
  "book-open",
  "book-open-bold",
  "brands",
  "calendar",
  "calendar-availability",
  "calendar-simple",
  "check",
  "check-circle",
  "check-circle-filled",
  "check-circle-overflow",
  "chevron-left",
  "chevron-right",
  "cog",
  "cog-simple",
  "company",
  "details",
  "devices",
  "direct-simple",
  "dynamic-pricing-arrow",
  "edit",
  "email",
  "eye",
  "hamburger",
  "handshake-circle",
  "heart",
  "heart-simple",
  "help",
  "help-simple",
  "hospitable",
  "hyperlink",
  "key",
  "key-simple",
  "language-translation",
  "light-bulb-shine",
  "like-bubble",
  "long-term-unoccupied",
  "matches-fire",
  "message",
  "message-simple",
  "metrics",
  "metrics-simple",
  "more",
  "not-allowed",
  "occupied",
  "ops",
  "ops-simple",
  "padlock",
  "phone",
  "pin-add-1",
  "post-stay",
  "preferences",
  "preferences-simple",
  "present",
  "properties",
  "properties-simple",
  "recurring-financial",
  "resolve",
  "scope",
  "search",
  "send",
  "settings-minimal",
  "smart-house-temperature",
  "star",
  "subscription",
  "subscription-simple",
  "sync",
  "tag",
  "task",
  "temperature-snowflake",
  "tick",
  "time",
  "trash",
  "unoccupied",
  "users",
  "users-simple"
] as const;

// Type for SVG names that use currentColor
export type SvgWithCurrentColor = typeof svgsUsingCurrentColor[number];
